import Typography from "components/typography";
import React from "react";
import { GetActiveArtist, GetUser } from "services/user/getUser";
import styled from "styled-components";
import { Colors } from "utils/colors";

const User = () => {
  const Artist = GetActiveArtist();

  return (
    <Container>
      <ImageBody>
        <ImageContainer>
          <NoImage>
            <Typography size="4rem" weight="medium">
              {Artist?.name[0]}
            </Typography>
          </NoImage>
          {/* <Image src = {} alt ={}/> */}
        </ImageContainer>
        <ImageUploadButton>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="12"
            height="12"
            viewBox="0 0 13 13"
            fill="none"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M4.03223 2.09677C4.03223 1.82063 4.23887 1.59677 4.49377 1.59677H7.57068C7.82558 1.59677 8.03223 1.82063 8.03223 2.09677C8.03223 2.37291 7.82558 2.59677 7.57068 2.59677H4.49377C4.23887 2.59677 4.03223 2.37291 4.03223 2.09677Z"
              fill="#FEB73D"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M4.92112 10.5968H7.14333C8.70388 10.5968 9.48413 10.5968 10.0446 10.2356C10.2872 10.0793 10.4956 9.87837 10.6577 9.64442C11.0322 9.10392 11.0322 8.35152 11.0322 6.84672C11.0322 5.34192 11.0321 4.58962 10.6576 4.04914C10.4955 3.81515 10.2872 3.61426 10.0445 3.45791C9.48403 3.09677 8.70378 3.09677 7.14328 3.09677H4.92103C3.36052 3.09677 2.58026 3.09677 2.01977 3.45791C1.77712 3.61426 1.56879 3.81515 1.40666 4.04914C1.03223 4.58951 1.03223 5.34157 1.03223 6.84572V6.84672C1.03223 8.35152 1.03223 9.10392 1.40674 9.64442C1.56887 9.87837 1.7772 10.0793 2.01985 10.2356C2.58035 10.5968 3.3606 10.5968 4.92112 10.5968ZM3.94889 6.84672C3.94889 5.73717 4.88163 4.83775 6.03223 4.83775C7.18283 4.83775 8.11558 5.73717 8.11558 6.84672C8.11558 7.95622 7.18283 8.85567 6.03223 8.85567C4.88163 8.85567 3.94889 7.95622 3.94889 6.84672ZM4.78223 6.84672C4.78223 6.18102 5.34188 5.64132 6.03223 5.64132C6.72258 5.64132 7.28223 6.18102 7.28223 6.84672C7.28223 7.51242 6.72258 8.05207 6.03223 8.05207C5.34188 8.05207 4.78223 7.51242 4.78223 6.84672ZM9.08778 4.83775C8.85768 4.83775 8.67113 5.01764 8.67113 5.23952C8.67113 5.46147 8.85768 5.64132 9.08778 5.64132H9.36558C9.59568 5.64132 9.78223 5.46147 9.78223 5.23952C9.78223 5.01764 9.59568 4.83775 9.36558 4.83775H9.08778Z"
              fill="#FEB73D"
            />
          </svg>
        </ImageUploadButton>
      </ImageBody>
      <Typography size="4xl" weight="semibold" mb="0.4" color={Colors.white300}>
        {Artist?.name}
      </Typography>
      <Typography size="s" color={Colors.grey300}>
        0 Releases
      </Typography>
    </Container>
  );
};

export default User;

const Container = styled.div`
  padding: 1.6rem 0;
  margin-left: auto;
  margin-right: auto;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const ImageBody = styled.div`
  margin-bottom: 0.8rem;
  position: relative;
  width: 8rem;
`;

const ImageUploadButton = styled.div`
  position: absolute;
  cursor: pointer;
  right: 0;
  bottom: 0;
  border-radius: 50%;
  border: 0.5px solid ${Colors.white300};
  background: ${Colors.grey700};
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2.2rem;
  height: 2.2rem;
`;

const ImageContainer = styled.div`
  width: 8rem;
  height: 8rem;
  border-radius: 50%;
`;
const NoImage = styled.div`
  width: 100%;
  height: 100%;
  border-radius: 50%;
  border: 1px solid ${Colors.white300};
  background-color: ${Colors.yellow400};
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${Colors.grey700};
`;

const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 50%;
`;
